// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.00195 1.99805H6.99805V4.00195H9.00195V1.99805Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.002 1.99805H10.998V4.00195H13.002V1.99805Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.002 1.99805H14.998V4.00195H17.002V1.99805Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 10V5H7V10H3V15H6.16228L9 15.9459L12 14.9459L15 15.9459L17.8377 15H21V10H17V5H15V10H13V5H11V10H9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 17H18.1623L15 18.0541L12 17.0541L9 18.0541L5.83772 17H3V20H1V22H23V20H21V17Z"}}]};

const CakeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cake-filled',
    ref,
    icon: element,
  },
));

CakeFilledIcon.displayName = 'CakeFilledIcon';

export default CakeFilledIcon;
